<template>
    <b-list-group-item :disabled="isDisabled" @click="goToNext()">
        <div class="list-title">
            <b-row>
                <b-col cols="12">
                    {{ model.partNumber }}
                </b-col>
            </b-row>
        </div>
        <div>{{ model.partName }}</div>
    </b-list-group-item>
</template>
<script>
export default {
    props: {
        model: {
            default: {},
            type: Object
        },
        isDisabled: {
            default: Boolean,
            type: false
        }
    },
    methods: {
        goToNext() {
            if(!this.isDisabled) {
                this.$emit('nextAction');
            }
        }
    },
    computed: {
        getStatusStyle() {
            return {
                color: this.model.isScanned == null || this.model.isScanned == false ? 'red' : 'green',
                // Add more styles as needed
            };
        },
    },
}
</script>
<style>
    .scanStatus {
        display: flex;
        font-size: 14px !important;
        align-items: center;
        justify-content: flex-end;
    }
</style>